import React from 'react';
import CollectionDialogs from '@/collections/containers/CollectionDialogs';
import DatasetDialogs from '@/datasets/containers/DatasetDialogs';
import CohortDialogs from '@/cohorts/containers/CohortDialogs';
import SearchDialogs from '@/search/containers/SearchDialogs';
import ThemeDialogs from '@/themes/components/ThemeDialogs';
import VocabularyDialogs from '@/vocabularies/containers/VocabularyDialogs';
import RoleDialogs from '@/roles/containers/RoleDialogs';
import TokenDialogs from '@/tokens/containers/TokenDialogs';
import UserDialogs from '@/users/containers/UserDialogs';
import UserGroupsDialogs from '@/users/groups/containers/UserGroupsDialogs';
import NotificationDialogs from '@/notifications/components/NotificationDialogs';
import RequestDialogs from '@/requests/components/RequestDialogs';
import WorkspaceDialogs from '@/workspaces/components/WorkspaceDialogs';
import Selectors from '../hooks/selectors';
import AboutDialog from './AboutDialog';

const AppDialogs = ({ theme }) => {
  const { allowAbout } = Selectors.useAbout();
  return (
    <div className="aridhia-app-dialogs">
      {allowAbout && (<AboutDialog theme={theme} />)}
      <CohortDialogs theme={theme} />
      <CollectionDialogs theme={theme} />
      <DatasetDialogs theme={theme} />
      <NotificationDialogs theme={theme} />
      <RequestDialogs theme={theme} />
      <RoleDialogs theme={theme} />
      <SearchDialogs theme={theme} />
      <ThemeDialogs theme={theme} />
      <TokenDialogs theme={theme} />
      <UserDialogs theme={theme} />
      <UserGroupsDialogs theme={theme} />
      <VocabularyDialogs theme={theme} />
      <WorkspaceDialogs theme={theme} />
    </div>
  );
};

export default AppDialogs;
